import React, { useState } from 'react';
import { Box, Typography, Card, CardMedia, Chip } from '@mui/material';
import NewsCard from './NewsCard';

const GridNewsView = ({ groupedNews, movieDetails }) => {
  const [selectedGroup, setSelectedGroup] = useState(null);

  const handlePosterClick = (tmdbId) => {
    setSelectedGroup(selectedGroup === tmdbId ? null : tmdbId);
  };

  const groupEntries = Object.entries(groupedNews);
  const selectedIndex = selectedGroup ? groupEntries.findIndex(([id]) => id === selectedGroup) : -1;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(3, 1fr)',
          sm: 'repeat(4, 1fr)',
          md: 'repeat(6, 1fr)',
          lg: 'repeat(8, 1fr)',
          xl: 'repeat(10, 1fr)'
        },
        gap: 1
      }}
    >
      {groupEntries.map(([tmdbId, articles], index) => {
        const movie = movieDetails[tmdbId];
        const isSelected = selectedGroup === tmdbId;
        
        return (
          <React.Fragment key={tmdbId}>
            {/* Poster */}
            <Card
              onClick={() => handlePosterClick(tmdbId)}
              sx={{
                position: 'relative',
                cursor: 'pointer',
                aspectRatio: '2/3',
                overflow: 'hidden',
                border: isSelected ? '3px solid' : 'none',
                borderColor: 'primary.main',
                '&:hover': { transform: 'scale(1.05)', transition: 'transform 0.2s', boxShadow: 4 }
              }}
            >
              <CardMedia
                component="img"
                image={movie?.poster || '/placeholder-movie.svg'}
                alt={movie?.name || 'Movie'}
                loading="lazy"
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, transparent 100%)',
                  p: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.5
                }}
              >
                <Typography variant="caption" sx={{ color: 'white', fontWeight: 700, fontSize: '0.7rem', lineHeight: 1.2 }}>
                  {movie?.name || 'Movie'}
                </Typography>
                <Chip 
                  label={`${articles.length}`}
                  size="small"
                  sx={{ 
                    height: 18,
                    fontSize: '0.65rem',
                    bgcolor: theme => theme.palette.mode === 'dark' ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.9)',
                    color: theme => theme.palette.mode === 'dark' ? 'white' : 'black',
                    fontWeight: 600,
                    width: 'fit-content'
                  }}
                />
              </Box>
            </Card>

            {/* Articles - Inline after selected poster */}
            {isSelected && (
              <Box sx={{ gridColumn: '1 / -1', mt: 2, mb: 2 }}>
                <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                  {movie?.name || 'Movie'} - {articles.length} Articles
                </Typography>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                      xs: '1fr',
                      sm: 'repeat(2, 1fr)',
                      md: 'repeat(3, 1fr)',
                      lg: 'repeat(4, 1fr)'
                    },
                    gap: 2
                  }}
                >
                  {articles.map((article) => (
                    <Box key={article.id} sx={{ height: 350 }}>
                      <NewsCard 
                        news={article} 
                        gridView 
                        onClick={() => window.open(`/news/${article.id}`, '_blank')}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default GridNewsView;